import LinkedIn from "../assets/bottom-nav/linkedin.svg";
import Youtube from "../assets/bottom-nav/youtube.svg";
import Instagram from "../assets/bottom-nav/insta.svg";

export const bottomNavIcons = [
  {
    icon: LinkedIn,
    action: "https://www.linkedin.com/company/coschoolai/",
  },
  {
    icon: Youtube,
    action: "https://youtube.com/@coschoolai?si=u5h_ExBavtI1NyDn",
  },
  {
    icon: Instagram,
    action: "https://www.instagram.com/coschoolai?igsh=ZWxvbWlwa2NmYnJh",
  },
];

export const bottomNavCompanyInfo = [
  {
    name: "About Us",
    path: "/about-us",
  },
  {
    name: "Contact us",
    path: "/school-partner",
  },
  {
    name: "Careers",
    path: "/careers",
  },
  {
    name: "Blog",
    externalPath: "https://coschool.medium.com/",
  },
];

export const bottomNavSupportInfo = [
  {
    name: "Chat on Whatsapp",
    externalPath: "https://wa.me/918977044305?text=Hello",
  },
];

export const locations = {
  main_office: "https://maps.app.goo.gl/ETVGBdjc9sz1fwAK9",
  jubilee_office: "https://maps.app.goo.gl/79LZYFynTs3f1pHj6",
};

export const isValidEmail = (email = "") =>
  /^[\w\-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);

export const isValidMobile = (number = "") => {
  return /^\d{10}$/.test(number);
};

export const isNonEmpty = (text = "") => text?.trim()?.length > 0;

export const isValidText = (text = "") => /^[a-zA-Z\s]+$/.test(text);

export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const getBrowserFingerprint = async () => {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('Browser Fingerprint', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText('Browser Fingerprint', 4, 17);
    const canvasData = canvas.toDataURL();
    const hash = btoa(canvasData).substring(0, 32);
    return hash;
  } catch (e) {
    return 'unknown-fingerprint';
  }
};

export const getExpirationDate = (hours = 24) => {
  const date = new Date();
  date.setHours(date.getHours() + hours);
  return date.toISOString();
};
